/**
 * @file paddle Wave Summit 2020 Hooks
 * @author FengGuang(fengguang01@baidu.com)
 */
import { useEffect, useState} from 'react';
import { fetchGetWS2021Data} from '../../api/pages/waveSummitPlus2021Api';
import {IActivityListProps} from './components/active-list/types';
import {IAwardsCeremonyProps} from './components/awards-ceremony/types';
import { Selectionprops } from './components/rules/type';
import { Shortlistedprops } from './components/shortlisted/type';

// 预请求
let preRequest: any = {
    fetchGetWS2021Data: fetchGetWS2021Data()
};

const useWaveSummitHooks = () => {
    const [introduce, setintroduce] = useState<string>('');
    const [rulesdec, setrulesdec] = useState<string>('');
    const [selection, setselection] = useState<Selectionprops>({});
    const [activityParticipation, setActivityParticipation] = useState<IActivityListProps>({});
    const [awardsCeremony, setAwardsCeremony] = useState<IAwardsCeremonyProps>({});
    const [shortlisted, setshortlisted] = useState<Shortlistedprops>({});

    useEffect(() => {
        (async () => {
            const res = await (preRequest.fetchGetWS2021Data || fetchGetWS2021Data())
                .catch(() => {
                    // ignore
                });
            delete preRequest.fetchGetWS2021Data;
            if (res) {
                const data = res.body.result.pageData || {};
                console.log(data)
                // 简介
                setintroduce(data.InfoCard?.desc ?? '');
                // 评选规则
                setrulesdec(data.rules?.desc ?? '');
                //评选具体规则
                const select = data.rule || {}
                const selectList: any[] = Array.isArray(select.list) ? select.list : [];
                setselection({
                    list: selectList.map((item) => ({
                        text: item.text,
                        title: item.title,

                    })),
                })
                // 参与方式
                const apm = data.activityParticipationMode || {};
                const apmList: any[] = Array.isArray(apm.list) ? apm.list : [];
                setActivityParticipation({
                    list: apmList.map((item) => ({
                        btnLink: item.btnLink,
                        btnText: item.btnText,
                        text: item.text,
                        title: item.title
                    })),
                    qrcode: apm.qrcode,
                    qrcodeLink: apm.qrcodeLink,
                    qrcodeTitle: apm.qrcodeTitle
                });
                // 奖项设置
                const ac = data.awardsCeremony || {};
                const acExplainList: any[] = Array.isArray(ac.explainList) ? ac.explainList : [];
                const acPrize: any[] = Array.isArray(ac.prize) ? ac.prize : [];
                setAwardsCeremony({
                    explainList: acExplainList,
                    prize: acPrize.map((item) => ({
                        imageUrl: item.imageUrl,
                        link: item.link,
                        title: item.title
                    }))
                });
                // 入围项目
                const obj = data.Shortlisted || {};
                const objList: any[] = Array.isArray(obj.list) ? obj.list : [];
                setshortlisted({
                    list: objList.map((item) => ({
                        btnLink: item.btnLink,
                        btnText: item.btnText,
                        content: item.content,
                        title: item.title,
                        imageUrl:item.imageUrl
                    })),
                });
            }
        })();
    }, [
        setintroduce,
        setActivityParticipation,
        setAwardsCeremony,
        setrulesdec,
        setselection,
        setshortlisted

    ]);

    return {
        introduce,
        activityParticipation,
        awardsCeremony,
        rulesdec,
        selection,
        shortlisted
    };
};

export default useWaveSummitHooks;
